import React from "react";
import {
  BrowserRouter,
  Navigate,
  Route,
  Routes as Routess,
} from "react-router-dom";
import { createBrowserHistory } from 'history'

//#region user
import { useSelector } from "react-redux";
import Layout from "../container/user/pages/layout/Layout";
import Home from "../container/user/pages/home/Home";
//#endregion



const history = createBrowserHistory();
export default function Routes() {

  const login = useSelector((state) => {
    return state.AdminReducer.isAdminLogin
  });
  // const login = true;

  return (
    <BrowserRouter history={history}>
      <Routess>
        <Route element={<Layout />}>
          <Route path="/" element={<Home/>} />
        </Route>
      </Routess>
    </BrowserRouter>
  );
}
